import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { TextArea } from '@td-client-frontend/common';
import { Nullable } from '../../../../../@types/common';
import { MarketingComment } from '../../../../../hooks/useMarketingComments';

interface CommentsTextAreas {
  onChange: (commentValue: string) => void;
  rightButtonLabel: string;
  textAreaName: string;
  textAreaLable?: string;
  isAddComment?: boolean;
  marketingComment?: Nullable<MarketingComment>;
  onClose?: () => void;
}

const CommentsTextArea: FC<CommentsTextAreas> = ({
  onChange,
  onClose,
  textAreaLable,
  rightButtonLabel,
  textAreaName,
  marketingComment = null
}) => {
  const [commentValue, setCommentValue] = useState<string>(marketingComment?.comment || '');

  const cancelCommentHandler = () => {
    setCommentValue('');
    onClose?.();
  };

  const onMarketingCommetsChange = (value: string) => {
    setCommentValue(value);
  };

  const changeCommentHandler = () => {
    if (commentValue.trim()) onChange(commentValue);
    cancelCommentHandler();
  };

  return (
    <div
      className={clsx('flex flex-col border-gray-20', !marketingComment?.comment && 'pb-6 border-b-1')}
      data-testid="marketing-comment-textarea-box"
    >
      <TextArea
        label={textAreaLable}
        name={textAreaName}
        value={commentValue}
        onChange={onMarketingCommetsChange}
        placeholder={!marketingComment?.comment ? 'Add your comments' : ''}
      />
      {commentValue && (
        <div
          className="flex w-full items-center justify-end space-x-6 mt-2 font-effra text-normal text-blue-80"
          data-testid="marketing-comment-buttons"
        >
          <button onClick={cancelCommentHandler} data-testid="marketing-comment-buttons-cancel">
            Cancel
          </button>
          <button onClick={changeCommentHandler}>{rightButtonLabel}</button>
        </div>
      )}
    </div>
  );
};

export default CommentsTextArea;
